<template>
    <div class="rec-city-container" v-if="list && list.length > 0">
        <h2 class="h2">{{$t('home_recom_hotel')}}</h2>

        <!-- 推荐城市列表 -->
        <ul class="rec-city-list">
            <li
                class="list-item"
                v-for="(item, i) in list"
                :key="i"
                v-lazy:background-image="item.images"
                @click="jump(item)"
            >
                <div class="list-item-inner">
                    <span class="city-name">{{item.city_name}}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { linkTo } from "@/lib/utils";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            list: [] //热门城市列表
        };
    },
    computed: {
        ...mapGetters(["hotelDater"])
    },
    created() {
        this.getHotCity();
    },
    methods: {
        getHotCity() {
            this.$req.post("v2/hotCity").then(({ data }) => {
                if (data.code === "2000") {
                    this.list = data.data;
                }
            });
        },

        /**
         * 跳转至酒店列表
         * @param {*} hotel 城市参数
         */
        jump(hotel) {
            this.$store
                .dispatch("searchHotelData", {
                    des: hotel,
                    dater: {
                        startDate: this.hotelDater.startDate,
                        endDate: this.hotelDater.endDate
                    }
                })
                .then(() => {
                    linkTo(`/hotel/list/${hotel.city_code}`);
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.rec-city-container {
    .h2 {
        font-weight: 500;
        font-size: 36px;
        margin-bottom: 50px;
        margin-top: 80px;
        text-align: center;
    }

    .rec-city-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .list-item {
            position: relative;
            width: 212px;
            height: 290px;
            border-radius: 2px;
            margin-bottom: 20px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            transition: all ease-in-out 0.3s;
            cursor: pointer;

            &:hover {
                transform: translateY(-5px);
                box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
            }

            .list-item-inner {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 82px;
                background: linear-gradient(
                    180deg,
                    rgba(0, 0, 0, 0) 0,
                    rgba(0, 0, 0, 0.67) 100%
                );
            }

            .city-name {
                position: absolute;
                bottom: 15px;
                left: 15px;
                color: #fff;
                font-size: 24px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/RecCity.vue